import axios from "axios";
import { FETCH_ALL_GIFT_API } from "../Constants/Apis";

export const getGifts = async () => {
  try {
    return axios.get(FETCH_ALL_GIFT_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createGift = async (payload) => {
  try {
    return axios.post(FETCH_ALL_GIFT_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateGift = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_GIFT_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteGift = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_GIFT_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

